import {useSelector} from 'react-redux';
import {Navigate, useLocation} from 'react-router-dom';

import * as React from "react";
import {RootState} from "../../../common/store";

// @ts-ignore
const CompleteSchoolDataGuard = ({children}) => {
    const location = useLocation()

    const school = useSelector((state: RootState) => state.school)

    return school.id ? children : <Navigate to="/school" state={{from: location}}/>
}

export default CompleteSchoolDataGuard
